// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchResults_container__n1mz_","extraInfo":"SearchResults_extraInfo__KAR6Y"};